import { Box } from "@mui/material"
import type { FC } from "react"

import { PricingTierReadOnly } from "./PricingTierReadOnly"
import { SpecialPricingHeader } from "./SpecialPricingHeader"

import { Button } from "@/components/common/Button"
import type { PriceChangeItem } from "@/graphql/codegen/graphql"
import type { ExistingSpecialRow } from "@/screens/Sales/hooks/useGetCustomerPricing"

interface SpecialPricingBlockProps {
  row: ExistingSpecialRow
  productId: number
  index: number
  onAdd: (special: PriceChangeItem) => void
}

export const SpecialPricingBlock: FC<SpecialPricingBlockProps> = ({ row, productId, index, onAdd }) => {
  const { item } = row

  return (
    <Box
      className='overflow-hidden rounded border border-tertiary-orange-300 bg-white'
      data-testid={`sales.product-pricing-form.special-block-${productId}-${index}`}
    >
      <SpecialPricingHeader row={row} />

      <Box className='flex items-start justify-between gap-3 p-3'>
        <PricingTierReadOnly tiers={item.tiers} />
        <Button
          appearance='outlined'
          size='small'
          onClick={() => onAdd(item as PriceChangeItem)}
          data-testid={`sales.product-pricing-form.special-add-button-${productId}-${index}`}
        >
          Add
        </Button>
      </Box>
    </Box>
  )
}
